import actionTypes from '../actions/actionTypes';

const INITIAL_STATE = {
  orderItems: [],
  totalHits: 0,
  loading: false,
  error: false,
};

const advancedSearchOrderHistory = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case actionTypes.GET_ORDERS_ACCORDING_TO_ADVANCED_PARAMS_LOADING:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case actionTypes.GET_ORDERS_ACCORDING_TO_ADVANCED_PARAMS_SUCCESS:
      return {
        ...state,
        orderItems: [...state.orderItems, ...payload.globalOrderSearchItems],
        loading: false,
        totalHits: payload.totalHits,
      };
    case actionTypes.GET_ORDERS_ACCORDING_TO_ADVANCED_PARAMS_ERROR:
      return {
        ...state,
        loading: false,
        error: payload,
      };
    case actionTypes.RESET_ORDERS_ACCORDING_TO_ADVANCED_PARAMS:
      return {
        ...INITIAL_STATE,
      };
    case actionTypes.RESTORE_ORDERS_ACCORDING_TO_ADVANCED_PARAMS:
      return {
        ...state,
        ...payload,
        loading: false,
      };
    default:
      return state;
  }
};

export default advancedSearchOrderHistory;
